import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  errorTranslate,
  objectifyForDropdown,
} from "../util";

export const getProductIndirectUseSoldList = ({
  productId,
  objectId,
  objects,
  setObjects,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/" + productId + "/indirect-use-sold",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        response.data.data.map((data) => {
          data.process_emitted = objectifyForDropdown(data.process_emitted);
          data.country_sold = objectifyForDropdown(data.country_sold);
          data.greenhouse = objectifyForDropdown(data.greenhouse);
          data.energy_added = objectifyForDropdown(data.energy_added);
          return data;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const addIndirectUseSoldToProduct = ({
  productId,
  country_sold,
  process_emitted,
  percentage_sold,
  energy_added,
  energy_added_times,
  amount_per_use,
  amount_per_lifetime,
  greenhouse,
  gas_charged,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    country_sold: country_sold,
    process_emitted: process_emitted || null,
    percentage_sold: percentage_sold,
    energy_added: energy_added || null,
    energy_added_times: energy_added_times || null,
    amount_per_use: amount_per_use || null,
    amount_per_lifetime: amount_per_lifetime || null,
    greenhouse: greenhouse || null,
    gas_charged: gas_charged || null,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/product/" + productId + "/indirect-use-sold",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
        setErrorMessage(error.response.data);
      }
    });
};

export const getProductIndirectUseSold = ({
  id,
  setObjects,
  objects,
  componentId,
}) => {
  var config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product/" +
      id +
      "/indirect-use-sold/" +
      componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          const gotValue = response.data.data;

          if (gotValue.id === supply.id) {
            gotValue.process_emitted = objectifyForDropdown(
              gotValue.process_emitted
            );
            gotValue.country_sold = objectifyForDropdown(gotValue.country_sold);
            gotValue.greenhouse = objectifyForDropdown(gotValue.greenhouse);
            gotValue.energy_added = objectifyForDropdown(gotValue.energy_added);
            return gotValue;
          }
          return supply;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateProductIndirectUseSold = ({
  productId,
  componentId,
  country_sold,
  process_emitted,
  percentage_sold,
  energy_added,
  energy_added_times,
  amount_per_use,
  amount_per_lifetime,
  greenhouse,
  gas_charged,
  objects,
  setObjects = function () {
    return;
  },
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    country_sold: country_sold,
    process_emitted: process_emitted || null,
    percentage_sold: percentage_sold,
    energy_added: energy_added || null,
    energy_added_times: energy_added_times || null,
    amount_per_use: amount_per_use || null,
    amount_per_lifetime: amount_per_lifetime || null,
    greenhouse: greenhouse || null,
    gas_charged: gas_charged || null,
  });

  var config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/indirect-use-sold/" +
      componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            response.data.data.process_emitted = objectifyForDropdown(
              response.data.data.process_emitted
            );
            response.data.data.country_sold = objectifyForDropdown(
              response.data.data.country_sold
            );
            response.data.data.greenhouse = objectifyForDropdown(
              response.data.data.greenhouse
            );
            response.data.data.energy_added = objectifyForDropdown(
              response.data.data.energy_added
            );
            return response.data.data;
          }
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      setErrorMessage(error.response.data);
    });
};

export const deleteProductIndirectUseSold = ({
  productId,
  componentId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/indirect-use-sold/" +
      componentId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};
